import { useCallback, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { backendBaseUrl } from '../config/backend';

export default function useWS({url = backendBaseUrl, roomId = 'sala-transcricao'}) {
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    // Só cria conexão se tiver roomId válido
    if (!roomId || roomId === 'aguardando-daily') {
      return;
    }

    // Criar conexão
    socketRef.current = io(url, {
      transports: ['websocket'],
    });

    const socket = socketRef.current;

    // Event handlers
    socket.on('connect', () => {
      setIsConnected(true);
      setError(null);
    });

    socket.on('room-joined', ({ context }) => {
      if (context && Array.isArray(context)) {
        setMessages([...context]);
      }
    });

    socket.on('message', (msg) => {
      // Adiciona mensagem ao array
      setMessages(prev => [...prev, msg]);
    });

    socket.on('reply', (data) => {
      if (data?.context && Array.isArray(data.context)) {
        setMessages([...data.context]);
      }
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
    });

    socket.on('error', (socketError) => {
      setError(socketError);
    });

    // Cleanup na desmontagem
    return () => {
      socket.disconnect();
    };
  }, [url, roomId]);

  // Função para enviar mensagem
  const sendMessage = useCallback((message) => {
    if (socketRef.current && isConnected) {
      // Aceita tanto string quanto objeto ChatMessage
      const messageToSend = typeof message === 'string' && message.trim() ? message : message;
      socketRef.current.emit('message', messageToSend);
      return true; // Sucesso
    }
    return false; // Falha
  }, [isConnected]);

  // Função para entrar em uma sala diferente
  const joinRoom = useCallback((newRoomId) => {
    if (socketRef.current && isConnected) {
      socketRef.current.emit('join-room', newRoomId);
    }
  }, [isConnected]);

  return {
    messages,
    isConnected,
    error,
    sendMessage,
    joinRoom
  };
}
